import { FetchAttr, TopDrug } from '../types';
import { getData } from '../utils';

type GetTopdrugsRequest = {
  translitname: string;
};

type GetTopdrugsResponse = TopDrug[];

const getTopDrugsByTranslitName = async (
  requestObj: GetTopdrugsRequest,
  attr?: FetchAttr
): Promise<GetTopdrugsResponse> => {
  if (!requestObj.translitname) {
    return [];
  }
  const response = await getData(
    `tradenames/${requestObj.translitname}/topdrugs`,
    attr
  );
  return response;
};

export default getTopDrugsByTranslitName;
